import React, { useEffect } from 'react'
import tw, { styled } from 'twin.macro'
import { useStateContext } from '@context/stateContext'
import Navbar from '@components/elements/Navbar'
import Footer from '@components/elements/Footer'
import Modal from '@components/elements/Modal/Modal'
import components from '../content/common'
import { AnimatePresence } from 'framer-motion'
import SubpageHeader from '@components/modules/SubpageHeader'
import Events from '@components/modules/Events'

const Container = styled.div`
  filter: ${(props) => (props.modal ? 'blur(20px)' : 'none')};
  image-rendering: ${(props) =>
    props.isChrome ? '-webkit-optimize-contrast !important;' : 'undefined'};
`

const ContentWrap = tw.div`max-w-master mx-auto pb-10 pt-5 sm:py-10 md:py-24 px-5`
const Heading = tw.h1`font-lobster text-green text-[22px] md:text-4xl tracking-[0.02em] md:leading-[50px] pb-5 md:pb-8`
const Text = tw.p`text-15px leading-[20px] text-gray font-roboto md:text-[24px] md:leading-[29px] lg:tracking-[0.02em] pb-5 md:pb-8`
const TextBold = tw.p`font-lobster text-heading text-xl md:text-4xl tracking-[0.02em]`

const EventsPage = () => {
  const { modal, modalHandle, sticky } = useStateContext()

  useEffect(() => {
    if (modal) {
      document.documentElement.style.overflowY = 'hidden'
    }
    return () => {
      document.documentElement.style.overflowY = 'auto'
    }
  }, [modal])
  const isChrome = typeof window !== 'undefined' && !!window.chrome
  return (
    <>
      <Container modal={modal} isChrome={isChrome}>
        <Navbar content={components.navbar} />
        <SubpageHeader />
        <ContentWrap>
          <Heading>
            Endlich wieder ordentlich feiern und a gscheide Gaudi! Das könnt ihr
            auf der „Alpin FM Festl Tour“ zusammen mit ERDINGER Brauhaus
            erleben.
          </Heading>
          <Text>
            Immer Sonntagnachmittag um 14 Uhr geht´s mit einem ruhigen Programm
            los. Da könnt ihr sche gmiatlich essen und die neuen Biere vom
            Brauhaus probieren. Wenn dann Stück für Stück die Stimmung
            hochgefahren wird, heizen unsere Bands euch richtig ein. Mit dabei
            sind unter anderem DeSchoWieda, Oimara und Monobo Son.
            <br />
            <br />
            Los gehts am 30.06. in Bad Reichenhall, danach gehts nach Oberammergau und über
            Ruhpolding zum Finale in Erding.
          </Text>
          <TextBold>Mia gfrein uns auf eich!</TextBold>
        </ContentWrap>
        <Events />
      </Container>
      <AnimatePresence exitBeforeEnter>
        {modal && <Modal key="modal" handleClose={() => modalHandle(false)} />}
      </AnimatePresence>
      <Footer stickyVisible={sticky} />
    </>
  )
}

export default EventsPage
